module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-calendar-year-container"
  }, [_c('div', {
    ref: "container",
    staticClass: "mu-calendar-year"
  }, [_c('div', {
    staticClass: "mu-calendar-year-list"
  }, _vm._l((_vm.years), function(year) {
    return _c('year-button', {
      key: 'yearButton' + year,
      attrs: {
        "year": year,
        "selected": year === _vm.selectedDate.getFullYear()
      },
      on: {
        "click": function($event) {
          _vm.handleClick(year)
        }
      }
    })
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0133970"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/datePicker/calendarYear.vue
// module id = 465
// module chunks = 1